import * as angular from 'angular';

import { IDataBackupRestoreService, ILoggerService } from '../../services';
import { BackupMetadata, ComponentDefinition } from '../../models';

class DataRestoreController implements angular.IComponentController {
    errorMessage: string;
    fileList: FileList;
    isLoading: boolean;
    loadingMessage: string;
    metadata: BackupMetadata;

    static $inject = [
        'dataBackupRestoreService',
        'loggerService'
    ];
    constructor(
        private _dataBackupRestoreService: IDataBackupRestoreService,
        private _loggerService: ILoggerService
    ) {
    }
    
    upload() {
        this.errorMessage = null;
        if (!!this.fileList && this.fileList.length > 0) {
            this.loadingMessage = 'Importing data';
            this.metadata = null;
            this.isLoading = true;
            this._dataBackupRestoreService
                .upload(this.fileList[0])
                .then(data => {
                    this.metadata = data.item1;
                    this._loggerService.logSuccess(`${data.item2} tasks created.`);
                })
                .catch(reason => {
                    this._loggerService.logError(reason.data.message || reason.data.Message);
                })
                .finally(() => {
                    this.fileList = undefined;
                    this.isLoading = false;
                });
        }
    }
}

export const wtDataRestore: ComponentDefinition = {
    componentId: 'wtDataRestore',
    controller: DataRestoreController,
    controllerAs: 'vm',
    template: require('./dataRestore.component.html'),
    bindings: {
        isLoading: '=',
        loadingMessage: '='
    }
};